<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="on-love">
<p style="padding-top: 150px; text-align: center;">I made every effort</p>
<p style="text-align: center;">to withstand your gravitational pull.</p>
<p style="text-align: center;">But it was simply too difficult</p>
<p style="text-align: center;">to resist something so beautiful.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?70b5be29